// Do NOT add "use client" to this file
import { getAltTag } from "@faire/retailer-visitor-shared/features/Marketplace/utils";
import { PRODUCT_TILE_SURFACE_MAP } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/__internal__/common";
import { getHelmetData } from "@faire/retailer-visitor-shared/views/search-v2/util/getHelmetData";
export var searchPageProductTileImagePropsAdapter = function(param) {
    var productName = param.productName, strictLocalize = param.strictLocalize, productTileSurface = param.productTileSurface, productSearchString = param.productSearchString, spellCorrectedQuery = param.spellCorrectedQuery, isFromDiscoverURL = param.isFromDiscoverURL, reviews = param.reviews, shouldUseLazyImageLoading = param.shouldUseLazyImageLoading, showVerticalImagery = param.showVerticalImagery, primaryImage = param.primaryImage, onLoad = param.onLoad;
    var finalQuery = spellCorrectedQuery === undefined ? productSearchString : spellCorrectedQuery;
    var title = getHelmetData(finalQuery, isFromDiscoverURL, strictLocalize, reviews).title;
    var templateAltTag = getAltTag({
        pageType: productTileSurface ? PRODUCT_TILE_SURFACE_MAP[productTileSurface] : undefined,
        title: title,
        productName: productName
    }, strictLocalize);
    var _primaryImage_alt_text;
    var imageAltText = (_primaryImage_alt_text = primaryImage.alt_text) !== null && _primaryImage_alt_text !== void 0 ? _primaryImage_alt_text : templateAltTag;
    return {
        image: primaryImage,
        imageAltText: imageAltText,
        shouldUseLazyImageLoading: shouldUseLazyImageLoading,
        showVerticalImagery: showVerticalImagery,
        onLoad: onLoad
    };
};
